module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.id) ? _c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('p', [_vm._v("Gasto Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.totalExpenses)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-edit'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('edit')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tDetalle\n\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-statistics'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('statistics')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEstadística\n\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-history'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('history')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tHistorial\n\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-options": "",
      "include-settings": ""
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.bookingCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.roomTypeCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingStart, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingEnd, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.totalExpenses), props.row.currency)))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "644"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columnsDetails,
      "rows": _vm.details,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-settings": false,
      "include-search": false,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.hour, 'HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.total), props.row.currency)))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "my-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tCerrar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03fc1306","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/companies/companies-history.vue
// module id = 1571
// module chunks = 73